import { Component, Injector }                              from '@angular/core';
import { BaseComponent }                                    from './BaseComponent';

@Component({
    selector      : 'LoggedBaseComponent',
    templateUrl   : 'LoggedBaseComponent.html',
  })
export class LoggedBaseComponent extends BaseComponent
{
    protected capability_name           = "";
    protected fallback_router           = "/403";
    

    constructor(injector: Injector) 
    {
        super(injector);
    }

    setCapabilityName(capability_name)
    {
        this.capability_name = capability_name;
    }

    getUserInfo()
    {
        return JSON.parse(this._localStorageService.getWatchedLocalStorage(this.project_labels + "_user_info"));
    }
    
    /**
     * Capabilities are stored in this way (Es. Auhtority):
     * UserInfo[ authority_permission ] [ can_access ] [ 2 ]
     * The method is called with parameters:
     * capability_name  => in this case authority_permission
     * entity_id        => in this case 2
     * capability_label => in this case can_access
     * If a permission_label is empty, user has not any permissions of that kind
     */
    checkCapability(capability_name , entity_id , capability_label)
    {
        let user_info = this.getUserInfo();
        if ( user_info === undefined || 
                user_info[capability_name][capability_label] === undefined ||
                    Object.keys(user_info[capability_name][capability_label][entity_id].length === 0)
            )
        {
            return false;
        }
        return true;
    }

    getCapabilities(capability_name , capability_label = null)
    {
        let user_info = this.getUserInfo();
        if (capability_label !== null)
        {
            return user_info[capability_name][capability_label];
        }
        return user_info[capability_name];
    }

    /**
     * Some section are accessible if user has at least one permission of one kind regardless
     * on which entity is or are
     * @param capability_name  = for example authority_permission
     * @param capability_label = for example can_manage
     * In this case it return True if at least one authority has been accessible with capability_label
     */
    hasAtLeastOne(capability_name, capability_label )
    {
        let user_info = this.getUserInfo();
        if (user_info[capability_name][capability_label] !== undefined)
        {
            return Object.keys(user_info[capability_name][capability_label]).length > 0;
        }
        return false;
    }

    isSuperUser()
    {
        return this._userService.isSuperuser();
    }

    getCurrentUserId()
    {
        return this.getUserInfo()["id"];
    }

    isCurrentUser(username)
    {
        let user_info = this.getUserInfo();
        return user_info["username"] === username;
    }

    checkInstanceCapability(element , capability_label)
    {
        return element["capabilities"].indexOf(capability_label) > -1;
    }

}
